import { createContext, useContext, useMemo, useState } from 'react'

export interface MovesSearch {
  /** Free-text pickup place (discovery intent; booking still uses saved points). */
  from: string
  /** Free-text drop-off place. */
  to: string
  /** Optional load-class key from GET /moves/load-classes. */
  loadClass: string
}

const EMPTY: MovesSearch = { from: '', to: '', loadClass: '' }

/** Where discovery results / home live. Committing a search lands here. */
export const MOVES_DISCOVERY_PATH = '/moves'

interface MovesSearchContextValue {
  search: MovesSearch
  setSearch: (next: MovesSearch) => void
}

export const MovesSearchContext = createContext<MovesSearchContextValue>({
  search: EMPTY,
  setSearch: () => {},
})

export function useMovesSearch(): MovesSearchContextValue {
  return useContext(MovesSearchContext)
}

export function useMovesSearchState(): MovesSearchContextValue {
  const [search, setSearch] = useState<MovesSearch>(EMPTY)
  return useMemo(() => ({ search, setSearch }), [search])
}
